import { Suspense, lazy } from "react";
import DashboardLayout from "../layouts/dashboard";
import { PATH_AUTOMATIONS } from "./paths";
import { Outlet } from "react-router-dom";
import AuthGuard from "../guards/AuthGuard";
import Loader from "@/components/Loader";

const AutomationsWorkflowsContainer = lazy(() => import("@pages/automations/automations.container"));

const automationRoutes = [
  {
    path: PATH_AUTOMATIONS,
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [{ element: <AutomationsWorkflowsContainer />, index: true }],
  },
];

export default automationRoutes;
